<script src="js/lib/angular.js"></script>
<script src="js/lib/angular-animate.js"></script>

<div>
  <iframe class ="main-img-container" allowfullscreen="true"
          src="https://momento360.com/e/u/51e061356d06498386e1550bf1da0743?utm_campaign=embed&utm_source=other&heading=0&pitch=0&field-of-view=75&size=medium"> </iframe>

  <span @textAnimation class="fade text-image">Rice Creek<br>Virtual Art Gallery</span>
  <span class="text-image-below"> Explore the works of SUNY Oswego Students using the interactive trail map. <br>
   Learn about the birds and animals depicted in the artworks of John Weeks and Diana Sweatt through our virtual gallery. <br>
    And enjoy the photographs of Rice Creek depicting the beauty of early spring!
</span>
  <div class="content" (click)="onScroll('second-component')">
    <svg id="more-arrows">
      <polygon class="arrow-top" points="37.6,27.9 1.8,1.3 3.3,0 37.6,25.3 71.9,0 73.7,1.3 "/>
      <polygon class="arrow-middle" points="37.6,45.8 0.8,18.7 4.4,16.4 37.6,41.2 71.2,16.4 74.5,18.7 "/>
      <polygon class="arrow-bottom" points="37.6,64 0,36.1 5.1,32.8 37.6,56.8 70.4,32.8 75.5,36.1 "/>
    </svg>
  </div>

  <div id="second-component">
    <div class = "map-container">
          <img src="assets/trailMap.jpg" usemap="#image_map">
        <map name="image_map">
          <area   style="cursor: pointer" (click)="showCardInfo(1)" coords="472,576,521,639" shape="rect">
          <area   style="cursor: pointer" (click)="showCardInfo(2)" coords="381,548,431,610" shape="rect">
          <area   style="cursor: pointer" (click)="showCardInfo(3)" coords="190,439,242,506" shape="rect">
          <area   style="cursor: pointer" (click)="showCardInfo(4)" coords="113,387,169,455" shape="rect">
          <area   style="cursor: pointer" (click)="showCardInfo(5)" coords="415,443,479,511" shape="rect">
          <area   style="cursor: pointer" (click)="showCardInfo(6)" coords="290,341,336,409" shape="rect">
          <area   style="cursor: pointer" (click)="showCardInfo(7)" coords="336,286,383,350" shape="rect">
          <area   style="cursor: pointer" (click)="showCardInfo(8)" coords="277,215,331,294" shape="rect">
          <area   style="cursor: pointer" (click)="onScroll('virtual-walk')" style="cursor: pointer" coords="289,501,364,565" shape="rect">
        </map>

      <div class ="beside-img-container" [hidden]="showImageTextConainter"> Explore the artwork of SUNY Oswego students
        from the 1980’s stored by the Rice Station. Although the artists’ names are not known, their work reflects the beauty found at Rice Creek - from depictions of quiet forest scenes, to studies of wildflowers and kingfishers.
        Click on <img src="assets/icon.png" width="29"> to see some more </div>
      <app-card class="card beside-img-container-card" [hidden]="!showImageTextConainter" [card]="imageMapModel"></app-card>


    </div>
  <div>
    <div class="trail-text">View our virtual art gallery depicting Rice Creek wildlife below. Explore the space by using your keyboard arrow keys (up, right, down and left) or by clicking where you want to go using your mouse.</div>
    <iframe id="virtual-walk"  style="width: 90%; height: 80vh; margin: 2%" src="https://www.artsteps.com/embed/607cb4586b15d0b1c3d06802/560/315" frameborder="0" allowfullscreen></iframe>
  </div>


  </div>
  <div>
    <div class="trail-text">These photographs were taken on the Green Trail of Rice Creek and depict the growth found during early spring.</div>
    <i class= "arrow-style move-right" (click)="moveLeft()">&#5171;</i>
    <i class = "arrow-style move-left"  (click)="moveRight()">&#5171;</i>

    <drag-scroll #nav>
        <app-card drag-scroll-item class="card" *ngFor="let card of cards" [card]="card"></app-card>
      </drag-scroll>

  </div>

  <div style="display: flex; flex-wrap: wrap; margin: 5%; color: white;background: #557957;">
    <div class = "side-container" style="width: 75%;">
    <div class="font-style"> For more information - contact the official Rice Creek Field Station: </div>
    <div class="font-style-smaller">Phone number: <span>315-312-6677</span></div>
      <div class="font-style-smaller "> Directons <button class="button-styling" (click)="naviagateToUrl()"> <img class= "google-img" src="https://img.icons8.com/doodle/48/000000/google-maps-new.png"/>Google Maps</button></div>
      <div class="font-style-smaller"> Visit the official website: <a style= "margin-left: 1%" target="_blank" href="https://www.oswego.edu/rice-creek/home"> SUNY Oswego Rice creek</a></div>
    </div>
    <div class="main-container">
      <img style="width: 80%;" src="./assets/circle-cropp.png">
    </div>
  </div>

</div>
